import MagnitudeStringConverter from '@migrate/utils/number/MagnitudeStringConverter'
import { NumberConverter } from '@portal/pkg-filter-criteria'
import PercentStringConverter from '@migrate/utils/number/PercentStringConverter'
import { StringConverter } from '@portal/pkg-filter-criteria'

export { NO_CURRENCY_SYMBOL } from '@portal/pkg-filter-criteria'
export const fromNumber = (value: number) => new NumberConverter(value)
export { fromNumberString } from '@portal/pkg-filter-criteria'
export const fromCurrencyString = (value: string) => new StringConverter(value)
export const fromPercentString = (value: string) => new PercentStringConverter(value)
// Recognizes a trailing `m`/`b` magnitude shorthand (e.g. `5m` → 5,000,000).
// Use only for values a user types into a numeric or currency field.
export const fromMagnitudeNumberString = (value: string) => new MagnitudeStringConverter(value)
